module.exports = __webpack_public_path__ + "assets/img/19.7f838485.png";